import { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import {
  compile_judge0_coding_user_action,
  create_submit_judge0_coding_user_action,
  get_submit_judge0_coding_user_action,
} from "../../../redux/_actions/common/test.actions";
import { useDispatch } from "react-redux";
function useAnswerQuestion(props) {
  const location = useLocation();
  const params = useParams()
  const dispatch = useDispatch();
  const [language, setLanguage] = useState(null);
  const [editorValue, setEditorValue] = useState(null);
  const [status, setStatus] = useState(null);
  const [output, setOutput] = useState(null);
  const [questionId, setQuestionId] = useState(null);
  const [questionDetails, setQuestionDetails] = useState(null);
  const [questionToken, setQuestionToken] = useState(null);
  const [compiledCode, setCompiledCode] = useState(null);
  const [languageDropdown, setLanguageDropdown] = useState([]);
  useEffect(() => {
    callLanguagesApi();
    getQuestionId();
  }, []);

  useEffect(() => {
    if(questionToken){
      submitQuestion();
    }
    
  }, [questionToken]);

  const submitQuestion = async () => {
    const data = {
      token: questionToken,
      question_submission: questionId,
      language_id: language,
    };
    const result = await dispatch(get_submit_judge0_coding_user_action(data));
  };

  const getQuestionId = () => {
    const questionId = params?.id;
    setQuestionId(questionId);
    if (questionId) {
      callQuestionDetailsApi(questionId);
    }
  };

  const callLanguagesApi = () => {
    const options = {
      method: "GET",
      url: "https://staging-api.jigsawapp.co/v1/judge0/get-judge0-languages/",
    };

    axios
      .request(options)
      .then(function (response) {
        setLanguageDropdown(response.data.data);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const callQuestionDetailsApi = (id) => {
    const options = {
      method: "GET",
      url: `https://staging-api.jigsawapp.co/v1/judge0/get-coding-question/${id}/`,
    };

    axios
      .request(options)
      .then(function (response) {
        setQuestionDetails(response.data.data);
      })
      .catch(function (error) {
        console.error(error);
      });
  };
  const onLanguageChange = (e) => {
    setLanguage(e.target.value);
  };
  function handleEditorChange(value, event) {
    // here is the current value

    setEditorValue(value);
  }

  const onSubmitCode = async () => {
    let val = {
      language_id: language,
      source_code: btoa(editorValue),
    };
    const result = await dispatch(create_submit_judge0_coding_user_action(val));
    if (result?.data) {
      setQuestionToken(result?.data?.token);
    }
  };

  const onCompileCode = async () => {
    let val = {
      language_id: language,
      source_code: btoa(editorValue),
    };
    const result = await dispatch(compile_judge0_coding_user_action(val));

    setCompiledCode(result?.data)
  };
  function handleEditorDidMount(editor, monaco) {
   
  }

  function handleEditorWillMount(monaco) {
  }

  function handleEditorValidation(markers) {
  }
  return {
    language,
    compiledCode,
    editorValue,
    languageDropdown,
    questionDetails,
    onSubmitCode,
    onLanguageChange,
    handleEditorChange,
    handleEditorDidMount,
    handleEditorWillMount,
    handleEditorValidation,
    onCompileCode
  };
}
export default useAnswerQuestion;
